import {
  HistorialCitasState,
  HistorialCitasViews,
  CitaProps,
  FilterBy,
  HistorialCitasFormParams,
  SortType,
} from 'utils/interfaces';
import { historialCitasInitialState } from '.';
import moment from 'moment';

export type Actions =
  | { type: 'reset' }
  | { type: 'setView'; payload: HistorialCitasViews }
  | { type: 'setStatusMessage'; payload?: string }
  | { type: 'showCitaCanceladaModal'; payload: boolean }
  | { type: 'saveFormParams'; payload?: HistorialCitasFormParams }
  | { type: 'setIdCita'; payload?: string }
  | { type: 'sortCitas'; payload: SortType }
  | { type: 'setCitas'; payload: { citas: CitaProps[], nombrePaciente: string } }
  | { type: 'setFormLoading'; payload: boolean }
  | { type: 'setFilterBy'; payload: FilterBy }
  | { type: 'setPageProximas', payload: number }
  | { type: 'setPagePrevias', payload: number }
  | { type: 'resetPages' };


const groupCitas = (
  group: { proximasCitas: CitaProps[]; previasCitas: CitaProps[] },
  current: CitaProps
) => {
  const { estadostr } = current;
  const proximasCitas = [
    ...group.proximasCitas,
    ...(estadostr === 'Pendiente' ? [current] : []),
  ];
  const previasCitas = [
    ...group.previasCitas,
    ...(estadostr !== 'Pendiente' ? [current] : []),
  ];
  return { proximasCitas, previasCitas };
};

const sortDates = (citas: CitaProps[], direction: SortType) => {
  const isAsc = direction === 'asc';
  return citas.sort((a, b) => {
    if (!a.formattedFecha || !b.formattedFecha) return 0;
    if (isAsc) return a.formattedFecha.localeCompare(b.formattedFecha);
    else return b.formattedFecha.localeCompare(a.formattedFecha);
  });
};

export function reducer(
  state: HistorialCitasState,
  action: Actions
): HistorialCitasState {
  switch (action.type) {
    case 'setView': {
      return {
        ...state,
        view: action.payload,
      };
    }
    case 'reset': {
      return historialCitasInitialState;
    }
    case 'setCitas': {
      const { citas, nombrePaciente } = action.payload;
      const formattedCitas = citas.map((cita) => ({
        ...cita,
        formattedFecha: moment(cita.fechaHora, 'DD/MM/YYYY hh:mm A').format(
          'YYYY/MM/DD HH:mm'
        ),
      }));
      const { proximasCitas, previasCitas } = formattedCitas.reduce(
        groupCitas,
        { proximasCitas: [], previasCitas: [] }
      );

      return {
        ...state,
        proximasCitas,
        previasCitas,
        nombrePaciente
      };
    }
    case 'setFormLoading': {
      return {
        ...state,
        isFormLoading: action.payload,
      };
    }
    case 'setFilterBy': {
      return {
        ...state,
        filterBy: action.payload,
      };
    }
    case 'setStatusMessage': {
      return {
        ...state,
        statusMessage: action.payload,
      };
    }
    case 'setIdCita': {
      return {
        ...state,
        idCita: action.payload,
      };
    }
    case 'showCitaCanceladaModal': {
      return {
        ...state,
        idCita: undefined,
        showCitaCanceladaModal: action.payload,
      };
    }
    case 'saveFormParams': {
      return {
        ...state,
        formParams: action.payload,
      };
    }
    case 'sortCitas': {
      const sortedPrevias = sortDates(state.previasCitas, action.payload);
      const sortedProximas = sortDates(state.proximasCitas, action.payload);
      return {
        ...state,
        sort: action.payload,
        previasCitas: sortedPrevias,
        proximasCitas: sortedProximas,
      };
    }
    case 'setPageProximas': {
      return {
        ...state,
        pageProximas: action.payload,
      };
    }
    case 'setPagePrevias': {
      return {
        ...state,
        pagePrevias: action.payload,
      };
    }
    case 'resetPages': {
      return {
        ...state,
        pageProximas: 0,
        pagePrevias: 0,
      };
    }
    default:
      return state;
  }
}
